import api from './api';
import { API_ENDPOINTS } from '../config/api.config';

export const fetchDerivedDataLatest = async (index = 'NIFTY', granularity = '1m', startTimestamp = null) => {
  try {
    const params = new URLSearchParams({ index });

    // Add granularity if specified (e.g., '1m', '5m', '15m')
    if (granularity) {
      params.append('granularity', granularity);
    }

    // Add start timestamp if specified (unix seconds)
    if (startTimestamp) {
      params.append('start', startTimestamp.toString());
    }

    const response = await api.get(`${API_ENDPOINTS.DERIVED_DATA_LATEST}?${params}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching latest derived data:', error);
    throw error;
  }
};

export const fetchDerivedDataSummary = async (index = 'NIFTY') => {
  try {
    const response = await api.get(`${API_ENDPOINTS.DERIVED_DATA_SUMMARY}?index=${index}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching derived data summary:', error);
    throw error;
  }
};